
// src/connects/user-notification-panel.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { emitAlertMessage } from '../actions/alert-message'
import NotificationAllSettingStore from '../actions/notification-all-setting-store'
import map from 'lodash/map'

export const mapStateToProps = (state)=> {
  return {
    isNotificationUpdating: state.user.isNotificationUpdating,
    isNotificationUpdateFailed: state.user.isNotificationUpdateFailed,
    notificationSettings: state.user.notificationSettings || { groups: undefined, others: undefined },
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: (props)=> {
      NotificationAllSettingStore.get((allSetting)=> {
        props.updateUI({ allSetting })
      })
      dispatch(actions.fetchNotificationSettings())
    },
    updateCollectiveSetting: (mediaType, notifyAll) => {
      dispatch(actions.updateNotificationCollectiveSetting(mediaType, notifyAll))
      dispatch(emitAlertMessage('label:一括変更しました', 'success'))
    },
    updateSetting: (target, notification, media, group = undefined, groups = undefined, isSameSetting, isAllPush)=> {
      dispatch(actions.updateNotificationSettings(target, notification, media, group && group.group_id || undefined))
      if (group) {
        dispatch(emitAlertMessage({ message: 'label:グループの通知設定を変更しました', name: group.name }, 'success'))
      } else {
        dispatch(emitAlertMessage( 'label:通知設定を変更しました', 'success'))
      }
    },

    setAllSettingToStore: (allSetting)=> NotificationAllSettingStore.set(allSetting),

    updateScheduleActive: (status)=> {
      dispatch(actions.updateScheduleActive(status))
    },

    updateScheduleType: (schedule_type)=> {
      dispatch(actions.updateScheduleType(schedule_type))
    },

    updateDaySchedule: (schedule_type, time_type, time_value)=> {
      dispatch(actions.updateDaySchedule(schedule_type, time_type, time_value))
    },

    updateCustomSchedule: (day_of_week, time_type, time_value)=> {
      dispatch(actions.updateCustomSchedule(day_of_week, time_type, time_value))
    },
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: {
    allSetting: 'all'
  }}),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/user-notification-panel.js